<div mat-dialog-title class="title">
  <span class="dialog-title-text">Office of Developmental Programs</span><br>
  <span class="dialog-title-text">{{consentTitle}} Performance-Based Contracting Attestation</span>
</div>

<mat-dialog-content #dialogContent style="color: black !important;">

  <div style="margin-top:25px;text-wrap: pretty;text-align: left;" [innerHTML]="consentNonSignPopUpHeaderHtmlContent"></div>


  <div style="pointer-events: none !important;">


    <div *ngFor="let que of consentOtherQuestions;let queInd = index;">

      <div *ngIf="que!= null">
        <div *ngIf="que.inputType === 'mul' && que.isParentQuestionVisible"
          [ngClass]="{'border-Btm': queInd +1 != consentOtherQuestions.length}">
          <app-inputType-mul [questionIndex]="queInd"
            [IsReadOnly]="true"    
            [question]=que (childQuestion)="UpdateResponse($event)">
          </app-inputType-mul>
          <!-- <ng-container *ngIf="showExtraComments" [ngTemplateOutlet]="Comments" [ngTemplateOutletContext]="{question: que}">
                  </ng-container> -->
        </div>
        <div *ngIf="que.inputType === 'chk' && que.isParentQuestionVisible"
          [ngClass]="{'border-Btm': queInd +1 != consentOtherQuestions.length  && que.isParentQuestionVisible}">
          <app-inputType-chk [questionIndex]="queInd"
            [IsReadOnly]="true"    
            [question]=que (childQuestion)="UpdateResponse($event)" [IsConsentScreen]="true" >
          </app-inputType-chk>
          <!-- <ng-container *ngIf="showExtraComments" [ngTemplateOutlet]="Comments" [ngTemplateOutletContext]="{question: que}">
                  </ng-container> -->
        </div>
        <div *ngIf="que.inputType === 'rdo' && que.isParentQuestionVisible"
          [ngClass]="{'border-Btm': queInd +1 != consentOtherQuestions.length}">
          <app-inputType-radio [questionIndex]="queInd"
            [IsReadOnly]="true"    
            [question]=que (childQuestion)="UpdateResponse($event)" [IsConsentScreen]="true" >
          </app-inputType-radio>
          <!-- <ng-container *ngIf="showExtraComments" [ngTemplateOutlet]="Comments" [ngTemplateOutletContext]="{question: que}">
                  </ng-container> -->
        </div>
        <div *ngIf="que.inputType === 'cmb' && que.isParentQuestionVisible"
          [ngClass]="{'border-Btm': queInd +1 != consentOtherQuestions.length}">
          <app-inputType-dropdown [questionIndex]="queInd"
            [IsReadOnly]="true"    
            [question]=que (childQuestion)="UpdateResponse($event)" [IsConsentScreen]="true">
          </app-inputType-dropdown>
          <!-- <ng-container *ngIf="showExtraComments" [ngTemplateOutlet]="Comments" [ngTemplateOutletContext]="{question: que}">
                  </ng-container> -->
        </div>
        <div
          *ngIf="que.questionText.length > 0 && (que.inputType === 'txb' || que.inputType === 'txa') && que.isParentQuestionVisible"
          [ngClass]="{'border-Btm': queInd +1 != consentOtherQuestions.length}">
          <app-inputType-text [questionIndex]="queInd"
            [IsReadOnly]="true"    
            [question]=que (childQuestion)="UpdateResponse($event)" [IsConsentScreen]="true">
          </app-inputType-text>
          <!-- <ng-container *ngIf="showExtraComments" [ngTemplateOutlet]="Comments" [ngTemplateOutletContext]="{question: que}">
                  </ng-container> -->
        </div>
        <div *ngIf="que.inputType === 'rating' && que.isParentQuestionVisible"
          [ngClass]="{'border-Btm': queInd +1 != consentOtherQuestions.length}">
          <app-inputType-rating [questionIndex]="queInd"
            [IsReadOnly]="true"    
            [question]=que (childQuestion)="UpdateResponse($event)">
          </app-inputType-rating>
          <!-- <ng-container *ngIf="showExtraComments" [ngTemplateOutlet]="Comments" [ngTemplateOutletContext]="{question: que}">
                  </ng-container> -->
        </div>
        <div *ngIf="que.inputType === 'dte' && que.isParentQuestionVisible"
          [ngClass]="{'border-Btm': queInd +1 != consentOtherQuestions.length}">
          <app-inputType-date [questionIndex]="queInd"
            [IsReadOnly]="true"    
            [question]=que (childQuestion)="UpdateResponse($event)">
          </app-inputType-date>
          <!-- <ng-container *ngIf="showExtraComments" [ngTemplateOutlet]="Comments" [ngTemplateOutletContext]="{question: que}">
                  </ng-container> -->
        </div>
        <div *ngIf="que.inputType === 'fileupload' && que.isParentQuestionVisible"
          [ngClass]="{'border-Btm': queInd +1 != consentOtherQuestions.length}">
          <app-inputType-fileUpload [questionIndex]="queInd"
            [IsReadOnly]="true"
            [question]=que [isReset]="false" (childQuestion)="UpdateResponse($event)">
          </app-inputType-fileUpload>
          <!-- <ng-container *ngIf="showExtraComments" [ngTemplateOutlet]="Comments" [ngTemplateOutletContext]="{question: que}">
                  </ng-container> -->
        </div>
        <div *ngIf="que.inputType === 'matrix' && que.isParentQuestionVisible"
          [ngClass]="{'border-Btm': queInd +1 != consentOtherQuestions.length}">
          <app-inputType-matrix [questionIndex]="queInd"
            [IsReadOnly]="true"
            [question]=que (childQuestion)="UpdateResponse($event)" [errorMessage]="que.errorMessage">
          </app-inputType-matrix>
          <!-- <ng-container *ngIf="showExtraComments" [ngTemplateOutlet]="Comments" [ngTemplateOutletContext]="{question: que}">
                  </ng-container> -->
        </div>
        <div *ngIf="que.inputType === 'sign' && que.isParentQuestionVisible"
          [ngClass]="{'border-Btm': queInd +1 != consentOtherQuestions.length}">
          <app-inputType-sign [questionIndex]="queInd"
            [IsReadOnly]="true"    
            [question]=que (childQuestion)="UpdateResponse($event)">
          </app-inputType-sign>
          <!-- <ng-container *ngIf="showExtraComments" [ngTemplateOutlet]="Comments" [ngTemplateOutletContext]="{question: que}">
                  </ng-container> -->
        </div>
        <div *ngIf="que.inputType === 'displaytext' && que.isParentQuestionVisible"
          [ngClass]="{'border-Btm': queInd +1 != consentOtherQuestions.length}">
          <div class="displayFlex">
            <app-input-type-display-text [questionIndex]="queInd"
              [IsReadOnly]="true"
              [question]=que (childQuestion)="UpdateResponse($event)">
            </app-input-type-display-text>
            <span class="my-2" style="font-size: 14px; text-align: justify;"></span>
          </div>
        </div>



      </div>
    </div>

  </div>




</mat-dialog-content>
<mat-dialog-actions align="end">
  <hr class="separator">
  <div class="d-flex justify-content-center align-items-center" style="margin-right: 1.5rem;">
    <button mat-button class="btn-style btnWidth-small" (click)="submitConsent()">Proceed</button>
    <button mat-button class="btn-style btnWidth-small" (click)="close()">Close</button>
  </div>
</mat-dialog-actions>

